
export const assessment = {
  title: 'Evaluación Conductual',
  instructions: 'Selecciona todas las palabras que sientes que te describen mejor',
  selectWords: 'Selecciona todas las palabras que sientes que te describen mejor:',
  progress: 'Progreso',
  complete: 'Completar Evaluación',
  selectedCount: 'Seleccionadas',
  totalWords: 'Total de Palabras',
  startAssessment: 'Iniciar Evaluación',
  behavior: {
    title: 'Evaluación Conductual',
    instruction: 'Selecciona todas las palabras que sientes que te describen mejor',
    subtitle: 'Descubre tu estilo conductual seleccionando palabras que mejor te describan'
  },
  instructionCards: {
    selectWords: {
      title: 'Seleccionar Palabras',
      description: 'Elige todas las palabras que sientes que te describen mejor'
    },
    beAuthentic: {
      title: 'Sé Auténtico',
      description: 'Selecciona palabras que realmente te representen'
    },
    takeYourTime: {
      title: 'Tómate Tu Tiempo',
      description: 'Sin prisa - reflexiona sobre cada elección'
    }
  },
  wordCounter: {
    selected: 'palabras seleccionadas'
  },
  wordCategories: {
    dominance: 'Impulso',
    influence: 'Conexión',
    steadiness: 'Tarea',
    conscientiousness: 'Orden',
    objectivity: 'Estilo'
  },
  completion: {
    title: '¡Evaluación Completa!',
    subtitle: 'Gracias por completar la evaluación.',
    viewResults: 'Ver Resultados',
    downloadPDF: 'Descargar Reporte PDF'
  },
  stages: {
    self: {
      title: 'Evaluación de Comportamiento Personal',
      subtitle: '¿Cómo te comportas naturalmente?',
      description: 'Selecciona palabras que describan tus tendencias conductuales naturales y preferencias',
      tip: 'Piensa en cómo actúas naturalmente cuando te sientes cómodo y siendo tú mismo'
    },
    work: {
      title: 'Evaluación de Comportamiento Laboral',
      subtitle: '¿Cómo esperan otros que te comportes en el trabajo?',
      description: 'Selecciona palabras que describan cómo colegas, gerentes y miembros del equipo esperan que actúes profesionalmente',
      tip: 'Piensa en las expectativas del lugar de trabajo, no en tus preferencias conductuales naturales'
    }
  },
  stageIndicator: {
    stage: 'Etapa',
    of: 'de'
  },
  controls: {
    continueToWork: 'Continuar al Comportamiento Laboral',
    viewResults: 'Ver Resultados Combinados',
    continue: 'Continuar',
    viewResultsButton: 'Ver Resultados',
    selectMoreWords: 'Selecciona {{count}} palabra{{plural}} más para continuar',
    selectAtLeast: 'Selecciona al menos {{min}} palabras ({{remaining}} más)',
    selected: 'seleccionadas',
    step: 'Paso',
    of: 'de',
    processing: 'Procesando...',
    minimumWords: 'Necesitas un mínimo de 8 palabras'
  },
  m3Instructions: {
    subtitle: 'Selecciona palabras que te describan auténticamente y continúa.',
    tip1: 'Elige palabras que reflejen tu comportamiento natural',
    tip2: 'No hay respuestas correctas o incorrectas',
    tip3: 'Toma aproximadamente 10 minutos',
    backToHome: 'Volver al inicio',
    aiWarningTitle: 'Aviso de Integridad Académica',
    aiWarningText: 'El uso de herramientas de IA, asistencia externa o cualquier recurso no autorizado está estrictamente prohibido. Nuestro sistema monitorea activamente patrones irregulares. Los candidatos que utilicen IA o ayuda externa serán inmediatamente descalificados.'
  },
  workBehavior: {
    title: 'Evaluación de Comportamiento Laboral',
    description: 'Selecciona palabras que describan cómo te comportas en el trabajo. Esto ayuda a identificar tu estilo de comportamiento profesional.',
    selectWords: 'Selecciona Palabras Que Describan Tu Comportamiento Laboral',
    selectWordsSubtitle: 'Elige palabras que mejor describan tu comportamiento laboral'
  }
};
